export const CONGRATS_ON_COURSE_END = 'congratsOnCourseEnd';
export const REQUEST_RESET_LINK = 'requestResetLink';
export const RESET_LINK_CONFIRM = 'resetLinkConfirm';
export const RESET_PASSWORD_CONFIRM = 'resetPasswordConfirm';
export const QUIZ_ON_COURSE_END = 'quizOnCourseEnd';
export const QUIZ_ON_QUIZ_SUBMIT = 'quizOnQuizSubmit';
export const BEFORE_QUIZ = 'beforeQuiz';
